export default [
  {
    header: 'instagram.menu-title',
  },
  {
    title: 'instagram.menu-add',
    route: 'owner:instagram-posts',
    icon: 'MessageCircleIcon',
  },
  {
    title: 'instagram.menu-enabled',
    route: 'owner:instagram-reports',
    icon: 'ListIcon',
  },
  {
    title: 'instagram.menu-templates',
    route: 'owner:instagram-reply-templates',
    icon: 'MenuIcon',
  },
  {
    header: 'instagram.stories-title',
  },
  {
    title: 'instagram.menu-add-stories',
    route: 'owner:instagram-stories',
    icon: 'MessageCircleIcon',
  },
  {
    title: 'instagram.story-mention',
    route: 'owner:instagram-story-mention',
    icon: 'HashIcon',
  },
]
